import { useModal } from '../contexts/ModalContext'
import FormularioRD from '../rdstation/formularioRD'
import CardsVerticais from './cardsVerticais'
import Container from './container'

export default function Expertise() {
  const { openModal } = useModal()
  // Define os conteúdos iniciais para cada seção
  const expertiseSections = [
    {
      title: 'Abordagem Personalizada',
      content:
        'Elaboramos soluções personalizadas para cada projeto, visando atender às necessidades específicas do cliente e otimizar suas chances de êxito.',
    },
    {
      title: 'Expertise',
      content:
        'Somos especialistas e temos profundo conhecimento sobre processos e requisitos da FINEP e disponibilizamos nossa experiência para elaboração e gestão do projeto de inovação para sua empresa.',
    },
    {
      title: 'Excelência',
      content:
        'Somos comprometidos com a excelência em toda jornada do projeto, da concepção até a implementação e acompanhamento, assegurando resultados de impacto nos seus projetos.',
    },
  ]

  return (
    <section className="bg-[url(../assets/banner-omnicore.png)] bg-cover text-white">
      <Container className="py-32 grid lg:grid-cols-2 items-center gap-12">
        <div className="md:space-y-6">
          <h3 className="font-inter-light text-center text-2xl lg:text-left md:text-4xl">
            Porque nos escolher para{' '}
            <strong className="font-inter-bold">
              desenvolver o seu projeto FINEP
            </strong>
            ?
          </h3>
          <button
            type="button"
            onClick={() => openModal(<FormularioRD />)}
            className="hidden md:mx-auto md:block lg:mx-0 bg-white font-bold py-3 px-8 rounded-full shadow-md hover:shadow-lg hover:scale-105 transition-all duration-300 cursor-pointer"
            style={{
              background: 'white',
              backgroundClip: 'padding-box',
            }}
          >
            <span className="bg-gradient-to-r from-[#FC0021] via-[#FC0021] to-[#5534D9] bg-clip-text text-transparent">
              Descubra nosso portfólio de soluções
            </span>
          </button>
        </div>

        <div>
          <CardsVerticais initialSections={expertiseSections} />
        </div>

        <button
          type="button"
          onClick={() => openModal(<FormularioRD />)}
          className="md:hidden bg-white font-bold py-4 md:py-3 px-4 md:px-8 rounded-full shadow-md hover:shadow-lg hover:scale-105 transition-all duration-300 cursor-pointer"
          style={{
            background: 'white',
            backgroundClip: 'padding-box',
          }}
        >
          <span className="bg-gradient-to-r from-[#FC0021] via-[#FC0021] to-[#5534D9] bg-clip-text text-transparent">
            Descubra nosso portfólio de soluções
          </span>
        </button>
      </Container>
    </section>
  )
}
